export const hoverColorClasses = {
    solid: {
        accent: 'hover:bg-accent-700',
        info: 'hover:bg-info-700',
        success: 'hover:bg-success-700',
        warning: 'hover:bg-warning-600',
        danger: 'hover:bg-danger-700',
        primary: 'hover:bg-black dark:hover:bg-slate-50',
        secondary: 'hover:bg-slate-700',
        tertiary: 'hover:bg-slate-600',
        quaternary: 'hover:bg-slate-500',
        black: 'hover:bg-black',
        white: 'hover:bg-white',
        none: '',
    },
    soft: {
        accent: 'hover:bg-accent-700/15 dark:hover:bg-accent-700/25 hover:text-accent-500 dark:hover:text-accent-500',
        info: 'hover:bg-success-700/15 dark:hover:bg-success-700/25 hover:text-info-600',
        success: 'hover:bg-success-700/15 dark:hover:bg-success-700/25 hover:text-success-700',
        warning: 'hover:bg-warning-600/15 dark:hover:bg-warning-600/25 hover:text-warning-600',
        danger: 'hover:bg-danger-700/15 dark:hover:bg-danger-700/25 hover:text-danger-700',
        primary: 'hover:bg-black dark:hover:bg-slate-50 hover:text-white',
        secondary: 'hover:bg-slate-700/15 dark:hover:bg-slate-700/25 hover:text-slate-600',
        tertiary: 'hover:bg-slate-600/15 dark:hover:bg-slate-600/25 hover:text-slate-500',
        quaternary: 'hover:bg-slate-500/15 dark:hover:bg-slate-500/25 hover:text-slate-400',
        black: 'hover:bg-black/15',
        white: 'hover:bg-white/15',
        none: '',
    },
    outline: {
        accent: 'hover:border-accent-700 hover:text-accent-700',
        info: 'hover:border-info-700 hover:text-info-700',
        success: 'hover:border-success-700 hover:text-success-700',
        warning: 'hover:border-warning-600 hover:text-warning-600',
        danger: 'hover:border-danger-700 hover:text-danger-700',
        primary: 'hover:border-black dark:hover:border-slate-50 hover:text-slate-950 dark:hover:text-slate-50',
        secondary: 'hover:border-slate-700 hover:text-slate-600',
        tertiary: 'hover:border-slate-600 hover:text-slate-500',
        quaternary: 'hover:border-slate-500 hover:text-slate-400',
        black: 'hover:border-black hover:text-black',
        white: 'hover:border-white hover:text-white',
        none: '',
    },
    ghost: {
        accent: 'hover:bg-accent-700/15 dark:hover:bg-accent-700/25 hover:text-accent-500 dark:hover:text-accent-500',
        info: 'hover:bg-success-700/15 dark:hover:bg-success-700/25 hover:text-info-600',
        success: 'hover:bg-success-700/15 dark:hover:bg-success-700/25 hover:text-success-700',
        warning: 'hover:bg-warning-600/15 dark:hover:bg-warning-600/25 hover:text-warning-600',
        danger: 'hover:bg-danger-700/15 dark:hover:bg-danger-700/25 hover:text-danger-700',
        primary: 'hover:bg-black dark:hover:bg-slate-50 hover:text-white',
        secondary: 'hover:bg-slate-700/15 dark:hover:bg-slate-700/25 hover:text-slate-600',
        tertiary: 'hover:bg-slate-600/15 dark:hover:bg-slate-600/25 hover:text-slate-500',
        quaternary: 'hover:bg-slate-500/15 dark:hover:bg-slate-500/25 hover:text-slate-400',
        black: 'hover:bg-black/15',
        white: 'hover:bg-white/15',
        none: '',
    },
    link: {
        accent: 'hover:text-accent-700 dark:hover:text-accent-500',
        info: 'hover:text-success-700 dark:hover:text-success-500',
        success: 'hover:text-success-700 dark:hover:text-success-500',
        warning: 'hover:text-warning-700 dark:hover:text-warning-500',
        danger: 'hover:text-danger-700 dark:hover:text-danger-500',
        primary: 'hover:text-black dark:hover:text-slate-50',
        secondary: 'hover:text-slate-700',
        tertiary: 'hover:text-slate-600',
        quaternary: 'hover:text-slate-500',
        black: 'hover:text-black',
        white: 'hover:text-white',
        none: '',
    },
};
